import {
    Toast
}
from 'vant';
Toast.setDefaultOptions({
    duration: 2000
});
Toast.show = Toast;
export default Toast;
// Toast.setDefaultOptions({
//     duration: 0
// });
// const toastLoading = Toast.loading({
//     duration: 0, // 持续展示 toast
//     forbidClick: true, // 禁用背景点击
//     loadingType: 'spinner',
//     message: ''
// });
// const toast = Toast({
//     duration: 0, // 持续展示 toast
//     forbidClick: true, // 禁用背景点击
//     // loadingType: 'spinner',
//     message: ''
// });



// const _Toast = class Storage {
//     show(data) {
//         toast.message = data;
//         this.clear();
//     }
//     success(data) {
//         toast.type = 'success';
//         toast.message = data;
//         this.clear();
//     }
//     fail(data) {
//         toast.type = 'fail';
//         toast.message = data;
//         this.clear();
//     }
//     /**
//      * 加载提示
//      * @param {*} data
//      */
//     loading(data) {
//         toastLoading.message = data;
//         this.clear();
//     }
//     clear() {
//         let second = 3;
//         const timer = setInterval(() => {
//             second--;
//             if (!second) {
//                 clearInterval(timer);
//                 Toast.clear();
//             }
//         }, 500);
//     }
// };

// export default new _Toast();
